<template>
  <div class="service-grid section_2 flex-col">
    <van-swipe
      v-if="items.length > 1"
      class="swipe-container"
      :loop="false"
      :show-indicators="true"
      indicator-color="rgba(4, 100, 202, 1)"
    >
      <van-swipe-item v-for="(page, pageIndex) in items" :key="pageIndex">
        <div class="grid-page">
          <div
            v-for="(item, idx) in page"
            :key="idx"
            class="grid-item"
            @click="handleClick(item)"
          >
            <img class="grid-icon" :src="item.icon" />
            <span class="grid-label">{{ item.label }}</span>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div v-else class="grid-page">
      <div
        v-for="(item, idx) in (items[0] || [])"
        :key="idx"
        class="grid-item"
        @click="handleClick(item)"
      >
        <img class="grid-icon" :src="item.icon" />
        <span class="grid-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { getColumnIdByName } from '../../utils/common'

export default {
  name: 'ServiceGrid',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
      return{
        items: this.buildServiceGridItems(),
      }
  },
  methods: {
    handleClick(item) {
      if (item.path) {
        this.$router.push(item.path)
      }
    },
    buildServiceGridItems() { 
      const c = getColumnIdByName
      const page = [
          { icon: require('../assets/img/icon-rycx.png'), label: '人员查询', path: '/person-query' },
          { icon: require('../assets/img/icon-gywm.png'), label: '关于我们', path: `/about-us` },
          { icon: require('../assets/img/icon-szyw.png'), label: '时政要闻', path: `/article-list?categoryId=${c('时政要闻')}` },
          { icon: require('../assets/img/icon-tbbd.png'), label: '特别报道', path: `/article-list?categoryId=${c('特别报道')}` },
          { icon: require('../assets/img/icon-qsls.png'), label: '青山绿水', path: `/article-list?categoryId=${c('青山绿水')}` },
          { icon: require('../assets/img/icon-yqjj.png'), label: '舆情聚焦', path: `/article-list?categoryId=${c('舆情聚焦')}` },
          { icon: require('../assets/img/icon-dwgg.png'), label: '对外公告', path: `/article-list?categoryId=${c('对外公告')}` },
          { icon: require('../assets/img/icon-fzbd.png'), label: '法治报道', path: `/article-list?categoryId=${c('法治报道')}` },
           
      ]
      const page2 = [
          { icon: require('../assets/img/icon-dyzw.png'), label: '调研追问', path: `/article-list?categoryId=${c('调研追问')}` },
          { icon: require('../assets/img/icon-rqfc.png'), label: '人企风采', path: `/article-list?categoryId=${c('人企风彩')}` },
          { icon: require('../assets/img/icon-ppls.png'), label: '品牌律所', path: `/article-list?categoryId=${c('品牌律所')}` },
          { icon: require('../assets/img/icon-jypx.png'), label: '企业培训', path: `/article-list?categoryId=${c('企业培训')}` },
          { icon: require('../assets/img/icon-kxpl.png'), label: '快讯评论', path: `/article-list?categoryId=${c('快讯评论')}` },
          { icon: require('../assets/img/icon-zmls.png'), label: '知名律师', path: `/article-list?categoryId=${c('知名律师')}` },
          { icon: require('../assets/img/icon-fund.png'), label: '环保基金', path: `/article-list?categoryId=${c('环保基金')}` },
          { icon: require('../assets/img/icon-zkzj.png'), label: '智库专家', path: `/article-list?categoryId=${c('智库专家')}` }, 
      ]
      const page3 = [
          { label: '法律援助', icon: require('../assets/img/icon-legal.png'), path: `/article-list?categoryId=${c('法律援助')}` },
          { label: '智慧应急', icon: require('../assets/img/icon-zhyj.png'), path: `/article-list?categoryId=${c('智慧应急')}`}
      ]
      return [page, page2,page3]
    },
  },

}
</script>

<style lang="scss" scoped>
.section_2 {
  background: url(../assets/img/bg-service-grid.png) -14px -12px no-repeat;
  background-size: 371px 215px;
  margin-top: 8px;
  padding: 15px 17px 13px 12px;

  .swipe-container {
    width: 100%;
    height: 165px;
  }

  .grid-page {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .grid-item {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 17px;
      cursor: pointer;
      transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

      &:active {
        transform: scale(0.92);
        opacity: 0.8;
      }

      .grid-icon {
        width: 44px;
      }

      .grid-label {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(68, 68, 68, 1);
        font-size: 12px;
        letter-spacing: -0.5px;
        text-align: center;
        white-space: nowrap;
        line-height: 18px;
        margin-top: 2px;
      }
    }
  }

  .divider {
    width: 36px;
    height: 3px;
    margin: 11px 137px 0 141px;
  }
}
</style>

<style lang="scss">
.service-grid {
  .swipe-container {
    position: relative;
    overflow: hidden;

    .van-swipe {
      height: 100% !important;
    }

    .van-swipe__track {
      display: flex !important;
      height: 100% !important;
    }

    .van-swipe-item {
      flex-shrink: 0 !important;
      height: 100% !important;
    }

    .van-swipe__indicators {
      position: absolute !important;
      left: 50% !important;
      bottom: 6px !important;
      transform: translateX(-50%) !important;
      display: flex !important;

      .van-swipe__indicator {
        width: 6px !important;
        height: 6px !important;
        border-radius: 50% !important;
        background-color: rgba(0, 0, 0, 0.3) !important;
        opacity: 1 !important;
        margin: 0 3px !important;

        &--active {
          background-color: rgba(4, 100, 202, 1) !important;
        }
      }
    }
  }
}
</style>
